import React, { useMemo, useEffect } from 'react';
import { Box, FormLabel, ListItemText, MenuItem, Select, Tooltip, Chip } from '@mui/material';
import CheckBox from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank';
import { useDispatch, useSelector } from 'react-redux';
import { setFilters } from '@/features/table/instantSearchSlice';
import { useLocation } from 'react-router-dom';
import { useInstantSearchOwnerFilters } from '@/hooks/useInstantSearchOwnerFilters';

export const ClientStatusTableListSelect = ({
	displayTitle,
	disabled,
	slug: slugProp,
	...props
}) => {
	const dispatch = useDispatch();
	const { pathname } = useLocation();
	const slug = slugProp ?? pathname;

	const { filters } = useInstantSearchOwnerFilters(slug);

	useEffect(() => {
		dispatch(
			setFilters({
				slug,
				type: 'isCurrent',
				values: ['isCurrent:= true'],
			}),
		);
	}, [dispatch, slug]);

	const refactoredItems = useMemo(
		() => [
			{
				label: 'Current',
				value: 'isCurrent:= true',
				isRefined: filters?.isCurrent?.includes('isCurrent:= true'),
			},
			{
				label: 'Not Current',
				value: 'isCurrent:!= true',
				isRefined: filters?.isCurrent?.includes('isCurrent:!= true'),
			},
		],
		[filters],
	);

	const handleChange = (value) => {
		const currentValues = filters?.isCurrent ?? [];
		if (currentValues.includes(value)) {
			dispatch(setFilters({ slug, type: 'isCurrent', values: [] }));
		} else {
			dispatch(setFilters({ slug, type: 'isCurrent', values: [value] }));
		}
	};

	const chosenValue = useMemo(
		() => refactoredItems.find((i) => i.isRefined)?.value ?? '',
		[refactoredItems],
	);

	const refinedLabels = refactoredItems.filter((i) => i.isRefined).map((i) => i.label);

	return (
		<Box>
			{displayTitle && <FormLabel>{'Client Status'}</FormLabel>}
			<Box>
				<Tooltip disableFocusListener title={refinedLabels.join(', ')} placement='top'>
					<Select
						fullWidth
						disabled={disabled}
						value={chosenValue}
						sx={{ display: 'flex', alignItems: 'center', minHeight: 35 }}
						renderValue={(selected) => {
							const selectedItem = refactoredItems.find((i) => i.value === selected);
							return selectedItem ? (
								<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
									<Chip size='small' label={selectedItem.label} />
								</Box>
							) : (
								''
							);
						}}
					>
						{refactoredItems.map((item) => (
							<MenuItem
								key={`select-${item.label}`}
								value={item.value}
								onClick={() => handleChange(item.value)}
							>
								<ListItemText primary={item.label} />
							</MenuItem>
						))}
					</Select>
				</Tooltip>
			</Box>
		</Box>
	);
};
